import styled from "styled-components";

export const EditEmployeeTransactionsContainer = styled.main`
	background: #fff;
	min-height: 75vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const EditItemsContainer = styled.section`
	padding: 25px 23px;
	padding-bottom: 0px;
	background-color: #fff;
	position: relative;

	h3 {
		margin: 0;
		color: #2e333e;
		font-size: 18px;
		font-weight: 600;
	}

	.ant-collapse {
		background-color: #fff;
	}

	.ant-collapse-item {
		margin-bottom: 16px;
	}

	.ant-collapse-header {
		background-color: #f2f6fa;
		font-weight: bold;
		padding: 12px 16px !important;
	}

	.ant-collapse-header-text {
		color: #2e333e;
		font-size: 16px; 
	}

	.ant-collapse-content-box {
		background-color: #fff;
		margin-top: 15px;
		padding: 0 16px;
	}

	.ant-select-selection-placeholder {
		color: #2e333e;
	}
`;

export const ActionButtonComponent = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	margin-top: 30px;
	margin-bottom: 20px;
	font-weight: bold;
`;